import React from "react";
import LoadingImg from "@common/assets/images/loading_view.gif"

function LoadingView () {
  return (
    <div className="loading-view">
      <img src={LoadingImg}/>
    </div>
  )
}

export default LoadingView
